/* istanbul ignore next */
import '@gjensidige/core-fonts';
import './style.scss';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BuildersComponentsTrackingProvider } from '@gjensidige/builders-components';
import { TrackingProvider } from '@gjensidige/core-analytics';
import { clientIdentification } from '@gjensidige/service-client-identification';
import { remoteLogWindowOnError } from '@gjensidige/service-error-handler';

import packageJson from '../package.json';
import { makeServer } from './__mocks__/server.mock';
import { tracker } from './utils/tracking';
import { ProductDocuments } from './components/ProductDocuments';
/* istanbul ignore if */
if (
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  !window.Cypress &&
  /* istanbul ignore next */ process.env.NODE_ENV === 'development'
) {
  makeServer({ environment: 'development' });
}

window.onerror = /* istanbul ignore next */ (event, ...rest) => {
  remoteLogWindowOnError(
    typeof event === 'string' ? event : event.toString(),
    ...rest
  );
};

clientIdentification.configure({
  clientId: 'product-document',
  clientVersion: packageJson?.version || /* istanbul ignore next */ ''
});

ReactDOM.createRoot(document.getElementById('product-document')!).render(
  <BuildersComponentsTrackingProvider options={tracker.options}>
    <TrackingProvider options={tracker.options}>
      <React.StrictMode>
        <ProductDocuments />
      </React.StrictMode>
    </TrackingProvider>
  </BuildersComponentsTrackingProvider>
);
